import {
  getTag,
  setTag
} from '../api/tag';


// eslint-disable-next-line import/prefer-default-export
export async function getAllTag(forOptions) {
  const allTags = await getTag();
  if (allTags) {
    const result = allTags.sort((a, b) => a.tag_name.localeCompare(b.tag_name));
    if (forOptions) {
      return result.map((t) => { return { value: t.tag_id, text: t.tag_name } });
    }
    return result;
  }
  return null;
}

export async function updateTag(tag) {
  const result = await setTag(tag);
  return result;

}
